import {
  DrydockFleetScreen,
  DrydockJobListScreen,
  DrydockLibraryScreen,
  DrydockProjectsScreen,
  PdiInspectionScreen,
} from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import {
  officeDrydockLibrarySource,
  officeDrydockProjectSource,
  officeDrydockScopeSource,
  officePdiInspectionSource,
} from '../drydock-source.js';

/** Maintenance (PMS) ▸ Dry Docking ▸ Projects (ADR 0129 Faz 1): filonun projeleri, salt okunur. */
export function DrydockProjectsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.pmsDrydockProjects')}>
      <DrydockProjectsScreen source={officeDrydockProjectSource} scope={officeDrydockScopeSource} />
    </Shell>
  );
}

/**
 * Maintenance (PMS) ▸ Dry Docking ▸ Fleet Overview (ADR 0129 Ek Faz 5): filonun projeleri, ofiste
 * bekleyen ve doğrulama bekleyen işler; yalnız ofis, salt okunur.
 */
export function DrydockFleetPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.pmsDrydockFleet')}>
      <DrydockFleetScreen projects={officeDrydockProjectSource} jobs={officeDrydockScopeSource} />
    </Shell>
  );
}

/**
 * Maintenance (PMS) ▸ Dry Docking ▸ Pre-Docking Inspection (ADR 0129 Ek Faz 2): filonun
 * denetimleri, gemi süzgeciyle, salt okunur.
 */
export function DrydockInspectionPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.pmsDrydockInspection')}>
      <PdiInspectionScreen source={officePdiInspectionSource} scope={officeDrydockScopeSource} />
    </Shell>
  );
}

/**
 * Maintenance (PMS) ▸ Dry Docking ▸ Yard Job List (ADR 0129 Ek Faz 3): filonun işleri; ofiste
 * bekleyen işlere Superintendent karar verir.
 */
export function DrydockJobsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.pmsDrydockJobs')}>
      <DrydockJobListScreen source={officeDrydockScopeSource} />
    </Shell>
  );
}

/**
 * Maintenance (PMS) ▸ Dry Docking ▸ Inspection Library (ADR 0129 Faz 1): şirketin Pre-Docking
 * kütüphanesi; düğüm yazma, varsayılan kütüphane, sürüm yayımı.
 */
export function DrydockLibraryPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.pmsDrydockLibrary')}>
      <DrydockLibraryScreen source={officeDrydockLibrarySource} />
    </Shell>
  );
}
